import React, { useState } from "react";
// estilos
import "../../estilos/mapaResultados.css";

// Botón flotante "cerca de mí" para /busqueda — mismo lugar y estilo que el de Home
// (seccionMapaHome.jsx), mismas restricciones (Colombia, ≥20 servicios, ver cercaDeMi.js en el
// backend). A diferencia de Home, este no renderiza su propio mapa: reusa el toggle Lista/Mapa
// que ya existe en esta página — al resolver la ubicación, `cargarServiciosMapaPorUbicacion`
// sincroniza `ciudad` y cambia a vista "mapa", así el mapa reemplaza a la lista de resultados
// (respetando los filtros de categoría/subcategoría/precio que ya estén activos). Si la ciudad
// resuelta no aplica, el botón desaparece sin dejar rastro, igual que en Home.
function BotonCercaDeMiBusqueda({ busqueda }) {
  const { vista, cargarServiciosMapaPorUbicacion } = busqueda;
  // "boton" | "buscando" | "oculto"
  const [estado, setEstado] = useState("boton");
  const [error, setError] = useState(null);

  function verCercaDeMi() {
    if (!navigator.geolocation) {
      setError("Tu navegador no permite compartir tu ubicación.");
      return;
    }

    setError(null);
    setEstado("buscando");

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const habilitada = await cargarServiciosMapaPorUbicacion(position.coords.latitude, position.coords.longitude);
        setEstado(habilitada ? "boton" : "oculto");
      },
      () => {
        setEstado("boton");
        setError("No pudimos acceder a tu ubicación. Actívala en el navegador e inténtalo de nuevo.");
      },
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 300000 }
    );
  }

  // Ya se está viendo el mapa (por este botón o por el dropdown de ciudad) — no hace falta el FAB.
  if (estado === "oculto" || vista === "mapa") return null;

  return (
    <div className="fab-cerca-de-mi-wrapper">
      <span className="fab-cerca-de-mi-etiqueta">
        {error || "Ver servicios cerca de mí"}
      </span>
      <button
        type="button"
        className="fab-cerca-de-mi"
        onClick={verCercaDeMi}
        disabled={estado === "buscando"}
        title="Ver servicios cerca de mí en el mapa"
        aria-label="Ver servicios cerca de mí en el mapa"
      >
        {estado === "buscando" ? (
          <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        ) : (
          <i className="bi bi-geo-alt-fill"></i>
        )}
      </button>
    </div>
  );
}

export default BotonCercaDeMiBusqueda;
